module.exports = __webpack_public_path__ + "static/for_merchants_art-94fb2f618e8c60711232ff2368a3866b.svg";